import { UUID_PATTERN } from './common';

/**
 * 견적 썸네일 키 형식 전체(견적↔주문 설계 §8, 견적 미리보기 설계 D6, 비회원 견적 설계 G18) — 두 형식을 받는다.
 * - 회원 견적: `users/{uuid}/quotes/{uuid}/{uuid}.webp` — 그룹 1 = user_id.
 * - 비회원 견적: `guests/quotes/{uuid}/{uuid}.webp` — 그룹 1 은 비어 있다(undefined). 회원 계정에 연결된 뒤에도 키는 그대로다.
 * 그룹 2 = 견적 요청 id(두 형식 공통). DB 는 thumbnail_key 형식을 검사하지 않으므로(유니크만)
 * worker 렌더(쓰기)와 보존 정리(키 검증 뒤 S3 삭제)가 이 형식을 함께 쓴다.
 */
export const QUOTE_THUMBNAIL_KEY_PATTERN = new RegExp(
  `^(?:users/(${UUID_PATTERN})|guests)/quotes/(${UUID_PATTERN})/${UUID_PATTERN}\\.webp$`,
);

/** 회원 견적 썸네일 키 조립 — worker 렌더는 이 함수(또는 비회원용 guestQuoteThumbnailKeyFor)로만 키를 만든다. */
export const quoteThumbnailKeyFor = (input: {
  readonly userId: string;
  readonly quoteRequestId: string;
  readonly fileId: string;
}): string => `users/${input.userId}/quotes/${input.quoteRequestId}/${input.fileId}.webp`;

/** 비회원 견적 썸네일 키 조립 — worker 는 견적의 user_id 가 없을 때 이 함수로 키를 만든다(보존 정리가 같은 패턴으로 검증한다). */
export const guestQuoteThumbnailKeyFor = (input: {
  readonly quoteRequestId: string;
  readonly fileId: string;
}): string => `guests/quotes/${input.quoteRequestId}/${input.fileId}.webp`;
